<template>
  <div class="bounty-headshot absolute transform -translate-x-1/2 cursor-default" :style="{ top: topPosition, left: leftPosition }">
    <img :src="headshotData.headshot" class="headshot-image" />
    <div class="headshot-label flex items-center justify-center gap-2 pl-1 py-1 pr-2 rounded-lg bg-neutral-25 w-max">
      <component :is="headshotData.platformIcon" />
      <BaseText type="label" size="xs" class="text-text-subdued">
        {{ headshotData.label }}
      </BaseText>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BountyHeadshot',
  props: {
    headshotData: {
      type: Object,
      required: true
    }
  },
  computed: {
    topPosition () {
      if (!this.headshotData?.position?.y) return 0
      return `${this.headshotData.position.y}px`
    },
    leftPosition () {
      if (!this.headshotData?.position?.x) return 0
      return `calc(50% + ${this.headshotData.position.x}px)`
    }
  }
}
</script>

<style scoped>
.headshot-label {
  position: absolute;
  top: calc(100% - 4px);
  left: 50%;
  transform: translateX(-50%);
  height: 28px;
}
.headshot-image {
  width: 68px;
  height: 68px;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: 50%;
  min-width: 68px;
  min-height: 68px;
  transition: transform 0.2s ease-in-out;
}
.bounty-headshot:hover .headshot-image {
  transform: scale(1.05) translateY(-2px);
}
</style>